<template>
  <el-dialog
    title="修改出租信息"
    :visible.sync="dialogVisible"
    width="88%"
    :close-on-click-modal="false"
    @close="handleClose"
    class="edit-rent-dialog"
    top="3vh"
  >
    <div class="dialog-content-wrapper">
      <vue-perfect-scrollbar class="scroll-area" :settings="scrollSettings">
        <el-form
          ref="formRef"
          :model="formData"
          :rules="formRules"
          label-width="180px"
          size="small"
          class="edit-rent-form"
        >
          <!-- ====== 第一部分：出租基本信息 ====== -->
          <div class="form-section">
            <div class="section-title">出租基本信息</div>

            <!-- 第1行：房屋地址（不可编辑） -->
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="房屋地址" prop="房屋地址">
                  <el-input v-model="formData.房屋地址" disabled />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第2行：租客姓名 + 联系电话 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="租客姓名" prop="租客姓名" required>
                  <el-input v-model="formData.租客姓名" placeholder="请输入租客姓名" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="联系电话" required>
                  <el-input
                    v-model="formData.联系电话"
                    placeholder="请输入联系电话"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <!--新增的 第3行：出房人 + 出房门店 + 合同编号 -->
<el-row :gutter="20">
  <el-col :span="8">
    <el-form-item label="出房人" prop="出房人">
      <el-input v-model="formData.出房人" placeholder="请输入出房人" />
    </el-form-item>
  </el-col>
  <el-col :span="8">
    <el-form-item label="出房门店" prop="出房门店">
      <el-input v-model="formData.出房门店" placeholder="请输入出房门店" />
    </el-form-item>
  </el-col>
  <el-col :span="8">
    <el-form-item label="合同编号" prop="合同编号">
      <el-input v-model="formData.合同编号" placeholder="请输入合同编号" />
    </el-form-item>
  </el-col>
</el-row>

            <!-- 第4行：开户行 + 银行卡号 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="开户行" prop="开户行">
                  <el-input v-model="formData.开户行" placeholder="请输入开户行" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="银行卡号" prop="银行卡号">
                  <el-input
                    v-model="formData.银行卡号"
                    placeholder="请输入银行卡号"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第5行：出房渠道 + 出房费用 + 出房押金 -->
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="出房渠道" prop="出房渠道">
                  <el-select v-model="formData.出房渠道" placeholder="请选择出房渠道" style="width:100%">
                    <el-option label="中介" value="中介" />
                    <el-option label="外网" value="外网" />
                    <el-option label="老客户介绍" value="老客户介绍" />
                    <el-option label="客户转租" value="客户转租" />
                    <el-option label="续租" value="续租" />
                    <el-option label="客户换房" value="客户换房" />
                    <el-option label="其他" value="其他" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出房费用（元）" prop="出房费用（元）" required>
                  <el-input-number
                    v-model="formData['出房费用（元）']"
                    :min="0"
                    :precision="2"
                    :step="100"
                    controls-position="right"
                    placeholder="请输入出房费用"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出房押金（元）" prop="出房押金（元）" required>
                  <el-input-number
                    v-model="formData['出房押金（元）']"
                    :min="0"
                    :precision="2"
                    :step="100"
                    controls-position="right"
                    placeholder="请输入出房押金"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第6行：合同起始日 + 合同到期日 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="合同起始日" prop="合同起始日" required>
                  <el-date-picker
                    v-model="formData.合同起始日"
                    type="date"
                    placeholder="请选择合同起始日"
                    value-format="timestamp"
                    style="width: 95%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="合同到期日" prop="合同到期日" required>
                  <el-date-picker
                    v-model="formData.合同到期日"
                    type="date"
                    placeholder="请选择合同到期日"
                    value-format="timestamp"
                    style="width: 95%"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第7行：出房租金 + 租金支付周期 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="出房租金（元/月）" prop="出房租金（元/月）" required>
                  <el-input-number
                    v-model="formData['出房租金（元/月）']"
                    :min="0"
                    :precision="2"
                    :step="100"
                    controls-position="right"
                    placeholder="请输入出房租金"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="租金支付周期" prop="租金支付周期" required>
                  <el-select v-model="formData.租金支付周期" placeholder="请选择支付周期" style="width:100%">
                    <el-option label="按月" value="按月" />
                    <el-option label="按季" value="按季" />
                    <el-option label="按半年" value="按半年" />
                    <el-option label="按年" value="按年" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第8行：物业/宽带费 + 物业宽带支付周期 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="物业/宽带费" prop="物业费" required>
                  <el-input-number
                    v-model="formData.物业费"
                    :min="0"
                    :precision="2"
                    :step="100"
                    controls-position="right"
                    placeholder="请输入物业/宽带费"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="物业宽带支付周期" prop="物业宽带支付周期">
                  <el-input
                    v-model="formData.物业宽带支付周期"
                    disabled
                    placeholder="与租金支付周期一致"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第9行：水电气押金 + 宠物押金 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="水电气押金" prop="水电气押金">
                  <el-input-number
                    v-model="formData.水电气押金"
                    :min="0"
                    :precision="2"
                    :step="100"
                    controls-position="right"
                    placeholder="请输入水电气押金"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="宠物押金" prop="宠物押金">
                  <el-input-number
                    v-model="formData.宠物押金"
                    :min="0"
                    :precision="2"
                    :step="100"
                    controls-position="right"
                    placeholder="请输入宠物押金"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第10行：特别约定 -->
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="特别约定" prop="特别约定">
                  <el-input v-model="formData.特别约定" type="textarea" :rows="2" placeholder="请输入特别约定" />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第11行：是否自用房 + 紧急联系人号码 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="是否自用房" prop="是否自用房">
                  <el-radio-group v-model="formData.是否自用房">
                    <el-radio label="是">是</el-radio>
                    <el-radio label="否">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="紧急联系人号码" prop="紧急联系人号码" required>
                  <el-input
                    v-model="formData.紧急联系人号码"
                    placeholder="请输入紧急联系人号码"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- ====== 第二部分：出租附件凭证 ====== -->
          <div class="form-section">
            <div class="section-title">出租附件凭证</div>

            <!-- 身份证信息 -->
            <div class="file-group">
              <div class="file-group-header">
                <span class="file-group-title">身份证信息</span>
                <el-button type="primary" size="small" icon="el-icon-upload2" @click="openUploadDialog('身份证信息')">
                  添加身份证信息
                </el-button>
              </div>
              <el-table :data="sfzList" border stripe size="small" v-loading="fileLoading">
                <el-table-column type="index" label="序号" width="60" align="center" />
                <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
                <el-table-column label="预览" width="150" align="center">
                  <template slot-scope="{ row }">
                    <div v-if="isImage(row.suffix) && row.preview_url" class="preview-thumbnail">
                      <el-image
                        :src="row.preview_url"
                        fit="cover"
                        style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                        :preview-src-list="[row.preview_url]"
                      />
                    </div>
                    <span v-else class="preview-placeholder">仅支持图片预览</span>
                  </template>
                </el-table-column>
                <el-table-column prop="upload_time" label="上传时间" width="170" align="center" />
                <el-table-column label="操作" width="200" align="center">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="mini" @click="handlePreviewFile(row)">查看</el-button>
                    <el-button type="text" size="mini" style="color: #f56c6c;" @click="handleDeleteFile(row, 'sfz')" :loading="row.deleting">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="sfzList.length === 0" class="empty-tip">
                暂无身份证信息文件
              </div>
            </div>

            <!-- 合同信息 -->
            <div class="file-group">
              <div class="file-group-header">
                <span class="file-group-title">合同信息</span>
                <el-button type="primary" size="small" icon="el-icon-upload2" @click="openUploadDialog('合同信息')">
                  添加合同信息
                </el-button>
              </div>
              <el-table :data="htList" border stripe size="small" v-loading="fileLoading">
                <el-table-column type="index" label="序号" width="60" align="center" />
                <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
                <el-table-column label="预览" width="150" align="center">
                  <template slot-scope="{ row }">
                    <div v-if="isImage(row.suffix) && row.preview_url" class="preview-thumbnail">
                      <el-image
                        :src="row.preview_url"
                        fit="cover"
                        style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                        :preview-src-list="[row.preview_url]"
                      />
                    </div>
                    <span v-else class="preview-placeholder">仅支持图片预览</span>
                  </template>
                </el-table-column>
                <el-table-column prop="upload_time" label="上传时间" width="170" align="center" />
                <el-table-column label="操作" width="200" align="center">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="mini" @click="handlePreviewFile(row)">查看</el-button>
                    <el-button type="text" size="mini" style="color: #f56c6c;" @click="handleDeleteFile(row, 'ht')" :loading="row.deleting">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="htList.length === 0" class="empty-tip">
                暂无合同信息文件
              </div>
            </div>
          </div>
        </el-form>
      </vue-perfect-scrollbar>
    </div>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确认修改</el-button>
    </span>

    <!-- ====== 上传文件弹窗 ====== -->
    <el-dialog
      :title="uploadDialog.title"
      :visible.sync="uploadDialog.visible"
      width="520px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="resetUploadForm"
    >
      <el-form :model="uploadForm" label-width="100px" size="small">
        <el-form-item label="选择文件" required>
          <el-upload
            ref="uploadRef"
            :auto-upload="false"
            :limit="1"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            action="#"
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
          >
            <el-button size="small" type="primary">点击选择文件</el-button>
            <span slot="tip" class="el-upload__tip">支持 jpg、jpeg、png、pdf、doc、docx</span>
          </el-upload>
          <div v-if="uploadForm.fileName" style="margin-top: 8px; font-size: 13px; color: #409EFF;">
            已选择：{{ uploadForm.fileName }}
          </div>
        </el-form-item>

        <!-- 图片预览 -->
        <el-form-item label="文件预览" v-if="uploadForm.localPreviewUrl">
          <el-image
            :src="uploadForm.localPreviewUrl"
            fit="cover"
            style="width: 100%; max-height: 200px; border-radius: 4px;"
          />
        </el-form-item>
        <el-form-item label="文件预览" v-else-if="uploadForm.fileName && !uploadForm.localPreviewUrl">
          <span style="color: #909399;">非图片文件，上传后可查看</span>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="uploadForm.bz" placeholder="请输入备注（可选）" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="uploadDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleUploadSubmit" :loading="uploading">确认</el-button>
      </span>
    </el-dialog>

    <!-- ====== 二次确认弹窗 ====== -->
    <el-dialog
      title="提示"
      :visible.sync="confirmDialog.visible"
      width="420px"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div style="text-align: center; padding: 20px 0;">
        <i class="el-icon-warning" style="font-size: 48px; color: #e6a23c;" />
        <p style="margin-top: 16px; font-size: 16px; color: #303133;">
          确认修改该出租信息吗？
        </p>
      </div>
      <span slot="footer">
        <el-button @click="confirmDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmSubmit" :loading="submitting">确认</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar' 
import { sqlBaseApi } from '@/api/通用/sqlBaseApi'
import { fileMethod } from '@/api/files/fileMethod'

export default {
  name: 'EditRentDialog',

  components: {
    VuePerfectScrollbar
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: null
    }
  },

  data() {
    const validateContractDate = (rule, value, callback) => {
      if (!value || !this.formData.合同起始日) {
        callback()
        return
      }
      if (value <= this.formData.合同起始日) {
        callback(new Error('合同到期日必须大于合同起始日'))
      } else {
        callback()
      }
    }

    return {
      dialogVisible: this.visible,
      submitting: false,
      uploading: false,
      fileLoading: false,

      scrollSettings: {
        wheelSpeed: 1,
        swipeEasing: true,
        suppressScrollX: false,
        wheelPropagation: false
      },

      // 表单数据
      formData: {
        房屋地址: '',
        租客姓名: '',
        联系电话: '',
        开户行: '',
        银行卡号: '',
        出房渠道: '中介',
        '出房费用（元）': null,
        '出房押金（元）': null,
        合同起始日: null,
        合同到期日: null,
        '出房租金（元/月）': null,
        租金支付周期: '按季',
        物业费: null,
        物业宽带支付周期: '按季',
        水电气押金: null,
        宠物押金: null,
        特别约定: '',
        是否自用房: '是',
        紧急联系人号码: '',
        房源ID: '',
        业务状态: '已出租'
      },

      formRules: {
        租客姓名: [
          { required: true, message: '请输入租客姓名', trigger: 'blur' }
        ],
        联系电话: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        '出房费用（元）': [
          { required: true, message: '请输入出房费用', trigger: 'blur' }
        ],
        '出房押金（元）': [
          { required: true, message: '请输入出房押金', trigger: 'blur' }
        ],
        合同起始日: [
          { required: true, message: '请选择合同起始日', trigger: 'change' }
        ],
        合同到期日: [
          { required: true, message: '请选择合同到期日', trigger: 'change' },
          { validator: validateContractDate, trigger: 'change' }
        ],
        '出房租金（元/月）': [
          { required: true, message: '请输入出房租金', trigger: 'blur' }
        ],
        租金支付周期: [
          { required: true, message: '请选择租金支付周期', trigger: 'change' }
        ],
        物业费: [
          { required: true, message: '请输入物业/宽带费', trigger: 'blur' }
        ],
        紧急联系人号码: [
          { required: true, message: '请输入紧急联系人号码', trigger: 'blur' }
        ]
      },

      // ====== 附件列表 ======
      sfzList: [],  // 身份证信息
      htList: [],   // 合同信息

      // 当前记录的 ID（用于附件上传）
      currentRecordId: null,

      // 上传弹窗
      uploadDialog: {
        visible: false,
        title: '添加文件'
      },
      uploadForm: {
        file: null,
        fileName: '',
        type_1: '',
        bz: '',
        localPreviewUrl: ''
      },
      currentType1: '',

      // 二次确认弹窗
      confirmDialog: {
        visible: false
      }
    }
  },

  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val && this.rowData) {
        this.initData()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
      if (!val) {
        this.resetForm()
      }
    },
    'formData.租金支付周期'(val) {
      this.formData.物业宽带支付周期 = val || ''
    }
  },

  methods: {
    // ====== 时间戳转毫秒（自动识别秒级/毫秒级） ======
    toMilliseconds(timestamp) {
      if (!timestamp) return null
      const str = String(timestamp)
      if (str.length === 10) {
        return timestamp * 1000
      }
      if (str.length === 13) {
        return timestamp
      }
      return timestamp
    },

    // ====== 初始化数据 ======
    initData() {
      if (!this.rowData) return

      const data = this.rowData

      // 保存当前记录 ID
      this.currentRecordId = data.id

      // 填充表单（时间戳转为毫秒级）
      this.formData = {
        房屋地址: data.房屋地址 || '',
        租客姓名: data.租客姓名 || '',
        联系电话: data.联系电话 || '',
        开户行: data.开户行 || '',
          出房人: data.出房人 || '',              // 新增
    出房门店: data.出房门店 || '',            // 新增
    合同编号: data.合同编号 || '',            // 新增
        银行卡号: data.银行卡号 || '',
        出房渠道: data.出房渠道 || '中介',
        '出房费用（元）': data['出房费用（元）'] !== undefined && data['出房费用（元）'] !== null ? data['出房费用（元）'] : null,
        '出房押金（元）': data['出房押金（元）'] !== undefined && data['出房押金（元）'] !== null ? data['出房押金（元）'] : null,
        合同起始日: this.toMilliseconds(data.合同起始日),
        合同到期日: this.toMilliseconds(data.合同到期日),
        '出房租金（元/月）': data['出房租金（元/月）'] !== undefined && data['出房租金（元/月）'] !== null ? data['出房租金（元/月）'] : null,
        租金支付周期: data.租金支付周期 || '按季',
        物业费: data.物业费 !== undefined && data.物业费 !== null ? data.物业费 : null,
        物业宽带支付周期: data['物业/宽带费支付周期'] || data.租金支付周期 || '按季',
        水电气押金: data.水电气押金 !== undefined && data.水电气押金 !== null ? data.水电气押金 : null,
        宠物押金: data.宠物押金 !== undefined && data.宠物押金 !== null ? data.宠物押金 : null,
        特别约定: data.特别约定 || '',
        是否自用房: data.是否自用房 || '是',
        紧急联系人号码: data.紧急联系人号码 || '',
        房源ID: data.房源ID || '',
        业务状态: data.业务状态 || '已出租'
      }

      // 加载附件列表
      this.loadAttachmentData()

      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },

    // ====== 重置表单 ======
    resetForm() {
      this.formData = {
        房屋地址: '',
        租客姓名: '',
        联系电话: '',
        开户行: '',
        出房人: '',              // 新增
    出房门店: '',            // 新增
    合同编号: '', 
        银行卡号: '',
        出房渠道: '中介',
        '出房费用（元）': null,
        '出房押金（元）': null,
        合同起始日: null,
        合同到期日: null,
        '出房租金（元/月）': null,
        租金支付周期: '按季',
        物业费: null,
        物业宽带支付周期: '按季',
        水电气押金: null,
        宠物押金: null,
        特别约定: '',
        是否自用房: '是',
        紧急联系人号码: '',
        房源ID: '',
        业务状态: '已出租'
      }
      this.sfzList = []
      this.htList = []
      this.currentRecordId = null
      this.submitting = false
      this.confirmDialog.visible = false
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
        if (this.$refs.uploadRef) {
          this.$refs.uploadRef.clearFiles()
        }
      })
    },

    // ====== 取消 ======
    handleCancel() {
      const hasData = Object.values(this.formData).some(val => {
        if (val === null || val === '' || val === undefined) return false
        if (Array.isArray(val) && val.length === 0) return false
        return true
      })

      if (hasData || this.sfzList.length > 0 || this.htList.length > 0) {
        this.$confirm('确定要取消吗？已修改的数据将丢失。', '提示', {
          type: 'warning'
        }).then(() => {
          this.dialogVisible = false
        }).catch(() => {})
      } else {
        this.dialogVisible = false
      }
    },

    // ====== 关闭弹窗 ======
    handleClose() {
      this.dialogVisible = false
    },

    // ====== 判断是否为图片 ======
    isImage(suffix) {
      if (!suffix) return false
      const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      return imageTypes.includes(suffix.toLowerCase())
    },

    // ====== 获取文件后缀 ======
    getFileSuffix(fileName) {
      const parts = fileName.split('.')
      return parts.length > 1 ? parts[parts.length - 1] : ''
    },

// ====== 加载附件数据 ======
async loadAttachmentData() {
  if (!this.currentRecordId) return

  this.fileLoading = true
  const type1List = ['身份证信息', '合同信息']
  // 从配置文件获取 fileBaseUrl，如果不存在则使用默认值
  const fileBaseUrl = window.applicationConfig?.fileBaseUrl || window.location.origin + '/nngy/'

  try {
    const promises = type1List.map(type1 => {
      return fileMethod.listFiles('出房管理', String(this.currentRecordId), type1, null)
        .then(res => {
          if (res.code === 200) {
            let data = res.data?.list || []
            data = data.map(item => {
              let fullUrl = ''
              if (item.show_path) {
                const isFullUrl = item.show_path.startsWith('http://') || item.show_path.startsWith('https://')
                // 如果 show_path 以 / 开头，去掉它再拼接
                const cleanPath = item.show_path.replace(/^\//, '')
                fullUrl = isFullUrl ? item.show_path : fileBaseUrl + cleanPath
              }
              console.log('文件预览URL:', fullUrl)  // 调试日志
              const isImageFile = this.isImage(item.suffix)
              return {
                ...item,
                show_path_full: fullUrl,
                preview_url: isImageFile ? fullUrl : ''
              }
            })
            return { type1, data }
          }
          return { type1, data: [] }
        })
        .catch(() => ({ type1, data: [] }))
    })

    const results = await Promise.all(promises)
    results.forEach(({ type1, data }) => {
      if (type1 === '身份证信息') {
        this.sfzList = data
      } else if (type1 === '合同信息') {
        this.htList = data
      }
    })
  } catch (error) {
    console.error('加载附件失败:', error)
  } finally {
    this.fileLoading = false
  }
},

    // ====== 打开上传弹窗 ======
    openUploadDialog(type1) {
      if (!this.currentRecordId) {
        this.$message.warning('请先保存基本信息')
        return
      }

      this.currentType1 = type1
      this.uploadDialog.title = `添加${type1}`
      this.uploadDialog.visible = true

      this.uploadForm.file = null
      this.uploadForm.fileName = ''
      this.uploadForm.type_1 = type1
      this.uploadForm.bz = ''
      this.uploadForm.localPreviewUrl = ''

      this.$nextTick(() => {
        if (this.$refs.uploadRef) {
          this.$refs.uploadRef.clearFiles()
        }
      })
    },

    // ====== 文件选择变化（生成本地预览） ======
    handleFileChange(file) {
      this.uploadForm.file = file.raw
      this.uploadForm.fileName = file.name
      this.uploadForm.localPreviewUrl = ''

      if (this.isImage(this.getFileSuffix(file.name))) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.uploadForm.localPreviewUrl = e.target.result
        }
        reader.readAsDataURL(file.raw)
      }
    },

    // ====== 文件移除 ======
    handleFileRemove() {
      this.uploadForm.file = null
      this.uploadForm.fileName = ''
      this.uploadForm.localPreviewUrl = ''
    },

    // ====== 重置上传表单 ======
    resetUploadForm() {
      this.uploadForm.file = null
      this.uploadForm.fileName = ''
      this.uploadForm.bz = ''
      this.uploadForm.localPreviewUrl = ''
      this.uploading = false
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles()
      }
    },

// ====== 上传附件 ======
async handleUploadSubmit() {
  if (!this.uploadForm.file) {
    this.$message.warning('请选择文件')
    return
  }

  if (!this.currentRecordId) {
    this.$message.warning('记录ID不存在，无法上传附件')
    return
  }

  this.uploading = true

  try {
    const res = await fileMethod.uploadFile(
      this.uploadForm.file,
      '出房管理',
      String(this.currentRecordId),
      this.uploadForm.type_1,
      '',
      this.uploadForm.bz || ''
    )
    console.log('上传返回:', res)

    if (res.code === 200) {
      const data = res.data || {}
      // 注意：/api/file/upload 返回的是驼峰命名：showName, showPath
      const showPath = data.showPath || ''
      const fileBaseUrl = window.applicationConfig?.fileBaseUrl || window.location.origin + '/nngy/'
      // 拼接完整 URL：fileBaseUrl + showPath（去掉开头的 /）
      const fullUrl = fileBaseUrl + showPath.replace(/^\//, '')
      console.log('拼接后的完整URL:', fullUrl)

      const isImageFile = this.isImage(data.suffix || this.getFileSuffix(this.uploadForm.file.name))

      const fileInfo = {
        id: data.fileId || data.id || null,
        save_name: data.saveName || '',
        save_path: data.savePath || '',
        show_name: data.showName || this.uploadForm.file.name,
        show_path: data.showPath || '',
        show_path_full: fullUrl,
        suffix: data.suffix || this.getFileSuffix(this.uploadForm.file.name),
        type_1: this.uploadForm.type_1,
        bz: this.uploadForm.bz || '',
        upload_time: new Date().toLocaleString(),
        preview_url: isImageFile ? fullUrl : '',
        deleting: false
      }

      if (this.currentType1 === '身份证信息') {
        this.sfzList.push(fileInfo)
      } else if (this.currentType1 === '合同信息') {
        this.htList.push(fileInfo)
      }

      this.$message.success('上传成功')
      this.uploadDialog.visible = false
    } else {
      this.$message.error(res.message || '上传失败')
    }
  } catch (error) {
    console.error('上传失败:', error)
    this.$message.error(error.message || '上传失败，请稍后重试')
  } finally {
    this.uploading = false
  }
},

    // ====== 预览文件 ======
    handlePreviewFile(row) {
      if (row.preview_url) {
        window.open(row.preview_url, '_blank')
      } else if (row.show_path_full) {
        window.open(row.show_path_full, '_blank')
      } else {
        this.$message.warning('文件路径不存在')
      }
    },

    // ====== 删除文件（立即调用后端接口） ======
    async handleDeleteFile(row, type) {
      if (!row.id) {
        this.$message.warning('文件ID不存在')
        return
      }

      this.$confirm(
        `确认删除文件 "${row.show_name}" 吗？删除后不可撤回！`,
        '提示',
        {
          type: 'warning',
          confirmButtonText: '确认删除',
          cancelButtonText: '取消'
        }
      ).then(async () => {
        // 设置删除状态
        if (type === 'sfz') {
          const target = this.sfzList.find(item => item.id === row.id)
          if (target) target.deleting = true
        } else {
          const target = this.htList.find(item => item.id === row.id)
          if (target) target.deleting = true
        }

        try {
          const res = await fileMethod.deleteFile(row.id)
          console.log('删除文件返回:', res)

          if (res.code === 200 && res.data?.deleted) {
            this.$message.success('删除成功')
            // 从列表中移除
            if (type === 'sfz') {
              this.sfzList = this.sfzList.filter(item => item.id !== row.id)
            } else {
              this.htList = this.htList.filter(item => item.id !== row.id)
            }
          } else {
            this.$message.warning(res.data?.message || '删除失败')
            // 重置删除状态
            if (type === 'sfz') {
              const target = this.sfzList.find(item => item.id === row.id)
              if (target) target.deleting = false
            } else {
              const target = this.htList.find(item => item.id === row.id)
              if (target) target.deleting = false
            }
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error(error.message || '删除失败，请稍后重试')
          // 重置删除状态
          if (type === 'sfz') {
            const target = this.sfzList.find(item => item.id === row.id)
            if (target) target.deleting = false
          } else {
            const target = this.htList.find(item => item.id === row.id)
            if (target) target.deleting = false
          }
        }
      }).catch(() => {})
    },

    // ====== 提交（第一步：二次确认弹窗） ======
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          this.$message.warning('请完善表单信息')
          return
        }
        this.confirmDialog.visible = true
      })
    },

    // ====== 确认提交（第二步：实际提交） ======
    async handleConfirmSubmit() {
      this.submitting = true

      try {
        // 构建提交数据
        const updateData = { ...this.formData }

        // 移除不需要提交的字段
        delete updateData.房屋地址
        delete updateData.房源ID
        delete updateData.业务状态

        // 处理日期：毫秒转秒
        if (updateData.合同起始日) {
          updateData.合同起始日 = Math.floor(updateData.合同起始日 / 1000)
        }
        if (updateData.合同到期日) {
          updateData.合同到期日 = Math.floor(updateData.合同到期日 / 1000)
        }

        // 移除空值字段
        Object.keys(updateData).forEach(key => {
          if (updateData[key] === null || updateData[key] === undefined || updateData[key] === '') {
            delete updateData[key]
          }
        })

        // 物业宽带支付周期映射到后端字段
        if (updateData.物业宽带支付周期) {
          updateData['物业/宽带费支付周期'] = updateData.物业宽带支付周期
          delete updateData.物业宽带支付周期
        }

        const params = {
          tableName: '出房管理',
          data: updateData,
          where: {
            id: this.currentRecordId
          }
        }

        console.log('修改提交参数===', params)

        const res = await sqlBaseApi.update(params)
        console.log('修改返回===', res)

        if (res.code === 200) {
          this.$message.success('修改成功！')
          this.confirmDialog.visible = false
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.message || '修改失败')
        }
      } catch (error) {
        console.error('修改请求失败===', error)
        this.$message.error(error.message || '修改失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.edit-rent-dialog /deep/ .el-dialog {
  max-height: 94vh;
  display: flex;
  flex-direction: column;
}

.edit-rent-dialog /deep/ .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 20px 20px 10px 20px;
}

.edit-rent-dialog /deep/ .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 12px 20px;
}

.dialog-content-wrapper {
  height: 70vh;
  overflow: hidden;
}

.scroll-area {
  height: 100%;
  padding-right: 10px;
}

/* ====== 表单分组 ====== */
.form-section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  padding: 10px 0;
  margin-bottom: 16px;
  border-bottom: 2px solid #409EFF;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 60px;
  height: 2px;
  background: #409EFF;
}

.edit-rent-form /deep/ .el-form-item {
  margin-bottom: 18px;
}

.edit-rent-form /deep/ .el-form-item__label {
  font-weight: 500;
  color: #606266;
  padding-right: 12px;
}

.edit-rent-form /deep/ .el-input-number {
  width: 100%;
}

.edit-rent-form /deep/ .el-input-number .el-input__inner {
  text-align: left;
}

.edit-rent-form /deep/ .el-select {
  width: 100%;
}

.edit-rent-form /deep/ .el-date-editor {
  width: 100%;
}

/* ====== 附件分组 ====== */
.file-group {
  margin-bottom: 24px;
}

.file-group:last-child {
  margin-bottom: 0;
}

.file-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0 10px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
}

.file-group-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.preview-thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-placeholder {
  font-size: 12px;
  color: #909399;
}

.empty-tip {
  text-align: center;
  padding: 12px 0;
  color: #909399;
  font-size: 13px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-top: 4px;
}

/* ====== 响应式 ====== */
@media (max-width: 768px) {
  .edit-rent-dialog /deep/ .el-dialog {
    width: 95% !important;
  }

  .dialog-content-wrapper {
    height: 50vh;
  }
}
</style>